import React, { ReactNode } from "react";
import { AiFillExclamationCircle } from "react-icons/ai";

import Button, { ButtonStyle } from "components/Button";

export const ConfirmModalStyle = {
  UPDATE_WITH_IS_PUBLIC: "updateWithIsPublic",
  CUSTOM: "custom",
  DELETE: "delete",
} as const;

type UpdateWithIsPublicProps = {
  style: "updateWithIsPublic";
  isPublic: boolean;
};

type DeleteProps = {
  style: "delete";
};

export type CustomProps = {
  style?: "custom";
  confirmText?: string;
  cancelText?: string;
  children?: ReactNode;
  buttonStyle?: (typeof ButtonStyle)[keyof typeof ButtonStyle];
};

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  ...props
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => Promise<void> | void;
} & (UpdateWithIsPublicProps | DeleteProps | CustomProps)) => {
  if (props.style === ConfirmModalStyle.UPDATE_WITH_IS_PUBLIC) {
    const { isPublic } = props;
    return (
      <ConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={onConfirm}
        confirmText="変更する"
        cancelText="閉じる"
        buttonStyle={ButtonStyle.PRIMARY}
        style={ConfirmModalStyle.CUSTOM}
      >
        <p>変更しますか？</p>
        <p className="mt-4 text-base">公開設定：{isPublic ? "公開" : "非公開"}</p>
      </ConfirmModal>
    );
  } else if (props.style === ConfirmModalStyle.DELETE) {
    return (
      <ConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={onConfirm}
        confirmText="削除する"
        cancelText="キャンセル"
        buttonStyle={ButtonStyle.RED_OUTLINE}
        style={ConfirmModalStyle.CUSTOM}
      >
        <div>
          <p className="flex items-center gap-2">
            <AiFillExclamationCircle fill="#DE4335" />
            削除しますか？
          </p>
        </div>
      </ConfirmModal>
    );
  }

  const { children, confirmText, cancelText, buttonStyle } = props;
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-10 overflow-y-auto">
      <div
        className="flex h-screen w-screen items-center justify-center bg-black bg-opacity-25 text-center"
        onClick={onClose}
      >
        <div
          className="mx-auto flex min-h-[250px] w-fit min-w-[400px] transform  flex-col justify-between  overflow-hidden rounded-lg
          bg-white pt-[4.5rem] shadow-card transition-all sm:my-[40vh] sm:align-middle"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-center text-xl">{children}</div>
          <div className="flex justify-center gap-4 py-5">
            {cancelText && (
              <div className="w-[160px]">
                <Button text={cancelText} onClick={onClose} style={ButtonStyle.OUTLINE} />
              </div>
            )}
            {confirmText && (
              <div className="w-[160px]">
                <Button text={confirmText} onClick={onConfirm} style={buttonStyle} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
